import { useId, type InputHTMLAttributes } from 'react';
import { Icon } from '../theme/Icon';
import { t } from '@app/i18n';
import s from './FilterInput.module.css';

export interface FilterInputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'value' | 'type' | 'id'
> {
  /** Rótulo visível à esquerda do campo. */
  label: string;
  value: string;
  onChange: (valor: string) => void;
  type?: 'text' | 'date' | 'search';
  /** Nota curta abaixo do campo (ex.: «aceita `*`»). */
  helperText?: string;
}

/**
 * Campo de filtro de grade (texto ou data) com o próprio «×» de limpar
 * (ajustes-3, 28/08, item 15.1). Vai na barra `filters` do `DataTable`, ao lado
 * dos `SearchCombobox clearable` — cada filtro se limpa sozinho, e o «Limpar
 * filtros» da barra continua limpando todos de uma vez.
 */
export function FilterInput({
  label,
  value,
  onChange,
  type = 'text',
  helperText,
  className,
  ...resto
}: FilterInputProps) {
  const id = useId();
  const noteID = `${id}-nota`;
  return (
    <span className={[s.campo, className].filter(Boolean).join(' ')}>
      <label htmlFor={id}>{label}</label>
      <span className={s.caixa}>
        <input
          id={id}
          type={type}
          value={value}
          aria-describedby={helperText ? noteID : undefined}
          onChange={(e) => onChange(e.target.value)}
          {...resto}
        />
        {value ? (
          <button
            type="button"
            className={s.limpar}
            aria-label={t('common.ui.clear', { label })}
            title={t('common.ui.clear', { label })}
            onClick={() => onChange('')}
          >
            <Icon name="close" size="xs" aria-hidden="true" />
          </button>
        ) : null}
      </span>
      {helperText ? (
        <span id={noteID} className={s.nota}>
          {helperText}
        </span>
      ) : null}
    </span>
  );
}
